import { useContext } from 'react'
import type { UseProfileReturn } from '@/types'
import { profileContext } from '../contexts/profile-context'

export const useProfile = (): UseProfileReturn => {
  const context = useContext(profileContext)

  if (!context) {
    throw new Error('useProfile must be used within ProfileProvider')
  }

  return context
}
